<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">@if (!aborted) {
    <span>Processing...</span>
    }@if (aborted) {
    <span>Aborting...</span>
  }
</h6>
</div>
<div class="modal-body">
  <app-progress-bar [value]="progress"></app-progress-bar>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary fw-bold" (click)="abort()" [disabled]="aborted">Abort</button>
</div>
